export default __webpack_public_path__ + "static/media/fink-pic.a4fd8fb1.png";